import React, { useState } from 'react';
import { Select } from '@rsos/components/capstone/base';
import useIsIRP from '@rsos/utils/useIsIRP';
import { customValueStyle } from '../SoundSelect/helpers';
import { trackChangeTT911RepeatTimes } from '../audioSettingsTrackings';
import { selectOptions, getFormattedValue } from './helpers';

const RepeatSelect = ({ isDisabled, repeatTimes, updateAudioSettings }) => {
  const { irpVersion } = useIsIRP();

  const [value, setValue] = useState(getFormattedValue(repeatTimes));
  const handleChange = option => {
    setValue(option);
    updateAudioSettings({ repeat_times: option.value });
    trackChangeTT911RepeatTimes(irpVersion, option.value);
  };

  return (
    <Select
      options={selectOptions}
      placeholder="Set number of repeats for sound"
      onChange={handleChange}
      styles={customValueStyle}
      value={value}
      isClearable={false}
      isDisabled={isDisabled}
    />
  );
};

export default RepeatSelect;
